module.exports = __webpack_public_path__ + "media/images/badge-top-ac1a7774a773dbdaa881bbf9e5b60d04.svg";